import { render, staticRenderFns } from "./modelDeatail.vue?vue&type=template&id=db99f128&scoped=true"
import script from "./modelDeatail.vue?vue&type=script&lang=js"
export * from "./modelDeatail.vue?vue&type=script&lang=js"
import style0 from "./modelDeatail.vue?vue&type=style&index=0&id=db99f128&prod&lang=scss"
import style1 from "./modelDeatail.vue?vue&type=style&index=1&id=db99f128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db99f128",
  null
  
)

export default component.exports